"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckBox = exports.CheckBoxElement = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const Colors_1 = require("../../Colors");
const Icon_1 = __importDefault(require("./Icon"));
const Input_1 = __importDefault(require("./Input"));
// CheckBoxElement 컴포넌트를 메모화하여 동일한 속성으로 렌더링 재사용
exports.CheckBoxElement = react_1.default.memo(({ style, isShowCheckBox = false, id, className, iconSize = 25, isRadioButton = false, title, checked, option, handlerCheck, isDisable, }) => {
    // 언어 번역을 위한 훅 사용
    const { t } = (0, react_i18next_1.useTranslation)();
    // 체크 상태 토글 함수
    const toggleChecked = e => {
        e.stopPropagation(); // Stop propagation to prevent bubbling
        handlerCheck && handlerCheck(id, !checked);
    };
    const handleClick = e => {
        e.stopPropagation(); // Stop propagation to prevent bubbling
    };
    // 컴포넌트 렌더링
    return (react_1.default.createElement("label", { className: `checkbox-item ${className}`, style: style },
        react_1.default.createElement("input", { type: "checkbox", disabled: isDisable, checked: checked, onChange: toggleChecked, onClick: handleClick }),
        react_1.default.createElement(Icon_1.default, { icon: checked
                ? isRadioButton && !isShowCheckBox
                    ? 'radio_checked'
                    : 'checked'
                : isRadioButton && !isShowCheckBox
                    ? 'radio_unchecked'
                    : 'unchecked', size: iconSize, fill: Colors_1.Colors.transparent }),
        !option?.input?.show && title && react_1.default.createElement("span", null,
            t(title),
            " "),
        option?.input?.show && (react_1.default.createElement(Input_1.default, { className: option.input?.className, type: "text", placeholder: option?.input?.placeholder, defaultValue: title, onChange: option?.input?.onChange
                ? value => option?.input?.onChange(id, value)
                : undefined, isDisable: isDisable }))));
});
exports.CheckBox = (0, react_1.forwardRef)(({ className, isRadioButton = false, isShowCheckBox = false, iconSize = 25, defaultCheckId = null, list, option, handlerCheck, isDisable, }, ref) => {
    const [selectedId, setSelectedId] = (0, react_1.useState)(null);
    const localRef = (0, react_1.useRef)(null);
    const handleCheck = (id, checked) => {
        if (isRadioButton) {
            if (checked) {
                setSelectedId(id);
                handlerCheck(id, true);
            }
        }
        else {
            handlerCheck(id, checked);
            if (checked) {
                setSelectedId(id);
            }
            else {
                setSelectedId(null);
            }
        }
    };
    (0, react_1.useImperativeHandle)(ref, () => ({
        reset: () => {
            setSelectedId(null);
        },
        ...localRef.current, // HTMLDivElement 속성을 포함
    }));
    (0, react_1.useEffect)(() => {
        if (selectedId !== defaultCheckId)
            setSelectedId(defaultCheckId);
    }, [defaultCheckId]);
    (0, react_1.useEffect)(() => {
        if (isRadioButton) {
            const checkedItem = list.find(item => item.checked);
            if (checkedItem && checkedItem.id !== selectedId) {
                setSelectedId(checkedItem.id);
            }
        }
    }, [list, isRadioButton]);
    (0, react_1.useImperativeHandle)(ref, () => ({
        reset: () => {
            setSelectedId(null);
        },
        ...localRef.current, // HTMLDivElement 속성을 포함
    }));
    return (react_1.default.createElement("div", { ref: localRef, className: `checkbox ${className}` }, list.map(item => (react_1.default.createElement(exports.CheckBoxElement, { key: item.id, iconSize: iconSize, option: option, isRadioButton: isRadioButton, isShowCheckBox: isShowCheckBox, ...item, checked: isRadioButton ? selectedId === item.id : item.checked, handlerCheck: handleCheck, isDisable: isDisable })))));
});
